const drawer = document.getElementById('search-drawer');
const overlay = document.getElementById('search-overlay');
const openBtn = document.getElementById('search-toggle');
const closeBtn = document.getElementById('search-close');

function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('active');
    document.body.classList.add('no-scroll');
}

function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.classList.remove('no-scroll');
}

openBtn.addEventListener('click', openDrawer);
closeBtn.addEventListener('click', closeDrawer);
overlay.addEventListener('click', closeDrawer);

/*Header signup & login popup js start*/
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector('.data-model-setup');
  const closeBtn = document.querySelector(".close-btn");
  const registerBtn = document.querySelector(".register-account-tab");
  const loginBtn = document.querySelector(".login-account-tab");
  const recoverBtn = document.querySelector(".recover-account-tab");
  const forgetcancelBtn = document.querySelector(".dawn-recover-cancel");

  // OPEN POPUP
  if (openBtn) {
    openBtn.addEventListener("click", function (e) {
      e.preventDefault();
      document.body.classList.add("data-model-setup-on");
    });
  }

  // CLOSE POPUP
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      document.body.classList.remove("data-model-setup-on");
    });
  }

  // REGISTER TAB
  if (registerBtn) {
    registerBtn.addEventListener("click", function () {
      document.getElementById("login").classList.remove("active");
      document.getElementById("register").classList.add("active");
      document.getElementById("recover").classList.remove("active"); // ADD THIS
    });
  }

  // LOGIN TAB
  if (loginBtn) {
    loginBtn.addEventListener("click", function () {
      document.getElementById("login").classList.add("active");
      document.getElementById("register").classList.remove("active");
      document.getElementById("recover").classList.remove("active"); // ADD THIS
    });
  }

  // RECOVER TAB
if (recoverBtn) {
  recoverBtn.addEventListener("click", function (e) {
    e.preventDefault();

    document.getElementById("login").classList.remove("active");
    document.getElementById("register").classList.remove("active");
    document.getElementById("recover").classList.add("active");

    document.getElementById("recover").classList.add("active");
  });
}
if (forgetcancelBtn){
  forgetcancelBtn.addEventListener("click", function (e){
     e.preventDefault();
     
     document.getElementById("register").classList.remove("active");
     document.getElementById("recover").classList.remove("active");
     document.getElementById("login").classList.add("active");
  });
}
}); 

document.addEventListener("click", function (e) {

  /* =========================
     DRAWER LOGIN CLICK
  ==========================*/
  const drawerLoginBtn = e.target.closest('.login-account-drawer a');

  if (drawerLoginBtn) {

    e.preventDefault();
    e.stopPropagation();

    openLoginPopup();

    // CLOSE DRAWER
    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    } else if (drawer) {
      drawer.classList.remove('active', 'animate');
      document.body.classList.remove('overflow-hidden');
    }

    return;
  }


});



// REUSABLE FUNCTION
function openLoginPopup() {

  document.body.classList.add("data-model-setup-on");

  document.getElementById("login").classList.add("active");
  document.getElementById("register").classList.remove("active");
  document.getElementById("recover").classList.remove("active");
}

/*App 50$ */ 


